<ion-action-sheet
  [isOpen]="isOpen"
  header="Let's find your best tow destination"
  i18n-header
  [buttons]="towActions()"
  (didDismiss)="handleAction($event)"
></ion-action-sheet>
